import { useMemo, useState } from 'react'
import { Card, CardContent } from '@axilon-apps/libs-ui-shadcn'
import { values, compact, compose, isEmpty } from '@axilon-apps/libs-shared-utils'
import { Collapse, FilterButton } from '@axilon-apps/libs-ui-components'

import UsersFilterForm from './UsersFilterForm'
import type { UsersFiltersFormValues } from '../../types/users-filters-form'

interface Props {
  onChange: (params: UsersFiltersFormValues) => void
  filters: UsersFiltersFormValues
  inline?: boolean
}

const isObjectValuesEmpty = compose(isEmpty, compact, values)

const UsersFilter = ({ onChange, filters, inline = false }: Props) => {
  const [expanded, setExpanded] = useState(false)
  const hasFiltersSelected = useMemo(() => !isObjectValuesEmpty(filters), [filters])

  const toggleFilters = () => {
    setExpanded((prevExpanded) => !prevExpanded)
  }

  if (inline) {
    return <UsersFilterForm onSubmit={onChange} filters={filters} showReset={false} />
  }

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-row justify-end">
        <FilterButton onClick={toggleFilters} selected={expanded} isDirty={hasFiltersSelected} />
      </div>
      <Collapse expanded={expanded}>
        <Card>
          <CardContent>
            <UsersFilterForm onSubmit={onChange} />
          </CardContent>
        </Card>
      </Collapse>
    </div>
  )
}

export default UsersFilter
